import { render } from "./annual-index.vue?vue&type=template&id=13097d71"
import script from "./annual-index.vue?vue&type=script&lang=js"
export * from "./annual-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__